/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HelpdeskGetAttachmentPathParameters } from 'api/actions/helpdesk-get-attachment/helpdesk-get-attachment-path-parameters';
import { HelpdeskGetAttachmentResponse } from 'api/actions/helpdesk-get-attachment/helpdesk-get-attachment-response';

type HelpdeskGetAttachmentQueryParameters = Record<string, any>;

/**
 * The path of the HelpdeskGetAttachment action.
 */
export const helpdeskGetAttachmentActionPath = new SweetPath<keyof HelpdeskGetAttachmentPathParameters>(
  '/help-desk/attachment/{attachmentId}.{ext}',
  { path: '{param}' }
);

/**
 * Creates a contextualized HelpdeskGetAttachment actions.
 */
export default function createHelpdeskGetAttachmentAction(axios: AxiosInstance) {
  return function helpdeskGetAttachmentAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: HelpdeskGetAttachmentPathParameters;
    query?: HelpdeskGetAttachmentQueryParameters;
  }) {
    const path = helpdeskGetAttachmentActionPath.insert(parameters);

    return axios.get<HelpdeskGetAttachmentResponse, HelpdeskGetAttachmentResponse>(path, { params: query, headers });
  };
}
